export const formatPrice = (price: number) => {
    if (isNaN(price)) return "";
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}